import { MapsRepository } from '../infra/maps/MapsRepository'
import { type Coordinate } from '../ui/components/map/Map'

export type GetGeocodeRepositoryParams = {
  repository: MapsRepository
}

export function getGeocodeFactory({ repository }: GetGeocodeRepositoryParams) {
  return async function getMapRoutesImpl(address: string): Promise<Coordinate | null> {
    const response = await repository.geocode(address)

    if (response && response.length > 0) {
      const [first] = response

      if (first.geometry) {
        const {
          geometry: { location },
        } = first

        return {
          lat: location.lat(),
          lng: location.lng(),
        }
      }

      return null
    }

    return null
  }
}

export function getGeocode(address: string) {
  const repository = new MapsRepository({
    directionsService: new google.maps.DirectionsService(),
    geocodeService: new google.maps.Geocoder(),
  })
  const get = getGeocodeFactory({ repository: repository })

  return get(address)
}
